import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
var normalizePost = function normalizePost(post) {
  var _post$price, _post$price$price, _post$price2, _post$price2$old_pric, _post$images_urls;
  post.tags = post === null || post === void 0 ? void 0 : post.new_tags.filter(function (t) {
    return !t.tag_name.includes("وفر") && !t.tag_name.includes("Save");
  }).map(function (tag) {
    return {
      text: tag === null || tag === void 0 ? void 0 : tag.tag_name,
      color: tag === null || tag === void 0 ? void 0 : tag.background_color
    };
  });
  post.sellingprice = post === null || post === void 0 ? void 0 : (_post$price = post.price) === null || _post$price === void 0 ? void 0 : (_post$price$price = _post$price.price) === null || _post$price$price === void 0 ? void 0 : _post$price$price.text;
  post.drop_price = post === null || post === void 0 ? void 0 : (_post$price2 = post.price) === null || _post$price2 === void 0 ? void 0 : (_post$price2$old_pric = _post$price2.old_price) === null || _post$price2$old_pric === void 0 ? void 0 : _post$price2$old_pric.text;
  post.discount = post === null || post === void 0 ? void 0 : post.save_money;
  post.product_url = "/cardetail/" + (post === null || post === void 0 ? void 0 : post.id);
  post.images_urls = ((post === null || post === void 0 ? void 0 : (_post$images_urls = post.images_urls) === null || _post$images_urls === void 0 ? void 0 : _post$images_urls.length) > 0 ? post.images_urls : [post.img_url]).filter(Boolean);
  return post;
};
export var api__listFavourite = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetcher().get("/customer/list-favourite");
        case 2:
          res = _context.sent;
          return _context.abrupt("return", res.data.data.posts.map(normalizePost));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__listFavourite() {
    return _ref.apply(this, arguments);
  };
}();
export var api__listFavouriteIds = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _res$data;
    var res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetcher().get("/customer/get-fav-post-ids")["catch"](function () {
            return {
              data: {
                data: []
              }
            };
          });
        case 2:
          res = _context2.sent;
          return _context2.abrupt("return", (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || []);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function api__listFavouriteIds() {
    return _ref2.apply(this, arguments);
  };
}();